'use strict'
import axios from 'axios';
import store from '../store';

export default class Init {
    static start() {
        const errorsCount = store.state.eligibilityErrorsCount;

        const initUrl = process.env.NODE_ENV === 'development' ? '/api/changechip/init' : '/changechip/init';
        return axios.get(initUrl, {
            headers: {
                retryAttempts: errorsCount
            }
        })
    }
}
